import React from "react";
import { motion } from "framer-motion";
import { MemoryRouter } from "react-router-dom";
import styles from "./Livetracker.module.scss";

// --- Centralized Inline SVGs ---
const Icons = {
  Check: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M5 12h14M12 5l7 7-7 7"></path>
    </svg>
  ),
  MapPin: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
  Route: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="6" cy="19" r="3"></circle>
      <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"></path>
      <circle cx="18" cy="5" r="3"></circle>
    </svg>
  ),
  Clock: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  Alert: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  ),
  Rupee: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M6 3h12M6 8h12M6 13l7 8M14 8c-3.3 0-6 2.7-6 6"></path>
    </svg>
  ),
  Phone: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.07 10.8 19.79 19.79 0 011 2.18 2 2 0 013 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7a16 16 0 006.92 6.92l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15z"></path>
    </svg>
  ),
  Target: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="6"></circle>
      <circle cx="12" cy="12" r="2"></circle>
    </svg>
  ),
  Dashboard: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),
  Users: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Code: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="16 18 22 12 16 6"></polyline>
      <polyline points="8 6 2 12 8 18"></polyline>
    </svg>
  ),
  Zap: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  EyeOff: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  ),
  File: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
      <polyline points="13 2 13 9 20 9"></polyline>
    </svg>
  ),
  Layers: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
      <polyline points="2 17 12 22 22 17"></polyline>
      <polyline points="2 12 12 17 22 12"></polyline>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  Analyze: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 5.25l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></path>
    </svg>
  ),
  Document: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <circle cx="10" cy="13" r="2"></circle>
      <line x1="11.4" y1="14.4" x2="15" y2="18"></line>
    </svg>
  ),
  AI: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
    </svg>
  ),
  User: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
    </svg>
  ),
  Visibility: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom Live Tracker Hero Art ---
const TrackerHeroArt = () => (
  <div className="product-hero-art" aria-hidden>
    <div
      className="product-hero-art-glow"
      style={{
        background:
          "radial-gradient(ellipse 70% 60% at 50% 40%, rgba(16, 185, 129, 0.22) 0%, transparent 70%)",
      }}
    />
    <svg
      className="product-hero-svg"
      viewBox="0 0 440 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="hero-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="route-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Grid Background */}
      <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
        <path
          d="M 40 0 L 0 0 0 40"
          fill="none"
          stroke="rgba(255,255,255,0.05)"
          strokeWidth="1"
        />
      </pattern>
      <rect
        width="100%"
        height="100%"
        fill="url(#grid)"
        className="anim-spin-slow"
        style={{ transformOrigin: "center", opacity: 0.5 }}
      />

      {/* Routes */}
      <path
        d="M 50 150 Q 150 50 250 180 T 400 120"
        stroke="url(#route-grad)"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="8 8"
        className="anim-dash"
      />
      <path
        d="M 80 250 Q 200 350 320 220"
        stroke="#38bdf8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="4 4"
        opacity="0.6"
        className="anim-dash"
        style={{ animationDirection: "reverse" }}
      />

      {/* Active Agents (Pins) */}
      <g className="anim-float" style={{ animationDelay: "0.2s" }}>
        <circle
          cx="250"
          cy="180"
          r="24"
          fill="rgba(16, 185, 129, 0.2)"
          stroke="#10b981"
          strokeWidth="2"
        />
        <circle
          cx="250"
          cy="180"
          r="8"
          fill="#10b981"
          filter="url(#hero-glow)"
        />
        <rect
          x="205"
          y="125"
          width="90"
          height="24"
          rx="4"
          fill="rgba(15, 23, 42, 0.9)"
          stroke="#10b981"
          strokeWidth="1"
        />
        <text
          x="215"
          y="141"
          fill="#10b981"
          fontSize="10"
          fontWeight="bold"
          fontFamily="sans-serif"
        >
          BA · Active
        </text>
      </g>

      <g className="anim-float" style={{ animationDelay: "0.7s" }}>
        <circle
          cx="320"
          cy="220"
          r="16"
          fill="rgba(245, 158, 11, 0.2)"
          stroke="#f59e0b"
          strokeWidth="2"
        />
        <circle
          cx="320"
          cy="220"
          r="6"
          fill="#f59e0b"
          filter="url(#hero-glow)"
        />
        <rect
          x="285"
          y="180"
          width="70"
          height="24"
          rx="4"
          fill="rgba(15, 23, 42, 0.9)"
          stroke="#f59e0b"
          strokeWidth="1"
        />
        <text
          x="295"
          y="196"
          fill="#f59e0b"
          fontSize="10"
          fontWeight="bold"
          fontFamily="sans-serif"
        >
          PK · Idle
        </text>
      </g>

      <g className="anim-float" style={{ animationDelay: "0.4s" }}>
        <circle
          cx="100"
          cy="100"
          r="20"
          fill="rgba(14, 165, 233, 0.2)"
          stroke="#0ea5e9"
          strokeWidth="2"
        />
        <circle
          cx="100"
          cy="100"
          r="6"
          fill="#0ea5e9"
          filter="url(#hero-glow)"
        />
        <rect
          x="60"
          y="55"
          width="80"
          height="24"
          rx="4"
          fill="rgba(15, 23, 42, 0.9)"
          stroke="#0ea5e9"
          strokeWidth="1"
        />
        <text
          x="70"
          y="71"
          fill="#0ea5e9"
          fontSize="10"
          fontWeight="bold"
          fontFamily="sans-serif"
        >
          VP · En Route
        </text>
      </g>

      {/* Radar Ping */}
      <circle
        cx="250"
        cy="180"
        r="80"
        stroke="#10b981"
        strokeWidth="1"
        fill="none"
        className="anim-ping"
      />
    </svg>
  </div>
);

const LiveTracker = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION */}
        <section className="product-hero-dark">
          <div className="product-hero-mesh" />
          <div className="product-hero-glow-1" />
          <div className="product-hero-glow-2" />

          <div className="sec-container">
            <div className="product-hero-row">
              <motion.div
                className="product-hero-inner"
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Live GPS Tracking ·
                  Pan India
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  Know Where Your <br />
                  <span className="product-text-gradient">Field Force</span> Is,
                  <br />
                  Right Now.
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Real-time location, attendance, and reimbursements — all in
                  one intelligent dashboard for India's most demanding field
                  teams.{" "}
                  <strong>
                    We provide an SDK to integrate tracking into any app
                  </strong>{" "}
                  — use ours or embed in yours.
                </motion.p>
                <motion.div className="product-pills" variants={childVariants}>
                  <span className="product-pill">1,400+ Active Agents</span>
                  <span className="product-pill">900+ KM Tracked/Mo</span>
                  <span className="product-pill product-pill-highlight">
                    99.5% Uptime SLA
                  </span>
                </motion.div>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Book a Demo
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    Start in Sandbox
                  </a> */}
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <TrackerHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. TRUSTED LOGOS */}
        <section
          className="product-section product-section-alt"
          style={{ padding: "4.8rem 0" }}
        >
          <div className="sec-container">
            <p
              className="product-strip-label"
              style={{ marginBottom: "2.4rem" }}
            >
              Trusted by field teams across industries
            </p>
            <div
              className="product-stats-strip"
              style={{ gap: "2.4rem", flexWrap: "wrap", opacity: 0.8 }}
            >
              {[
                "BFSI · Collections",
                "Credit CPV / CPD",
                "Technical Services",
                "Sales & Distribution",
                "Field Inspections",
              ].map((logo) => (
                <div
                  key={logo}
                  style={{
                    padding: "1.2rem 2.4rem",
                    background: "#f1f5f9",
                    borderRadius: "1.2rem",
                    fontSize: "1.4rem",
                    fontWeight: 600,
                    color: "#475569",
                  }}
                >
                  {logo}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. PROBLEM SECTION */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span
                className="product-section-eyebrow"
                style={{
                  backgroundColor: "#fee2e2",
                  color: "#ef4444",
                  borderColor: "#fecaca",
                }}
              >
                The Challenge
              </span>
              <h2 className="gen-h2">
                Lack of Visibility is Costing Your Business
              </h2>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.EyeOff />
                </div>
                <h3 className="product-card-title">No real-time visibility</h3>
                <p className="product-card-desc">
                  Managers cannot see where teams are or what they are doing in
                  the field.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.Route />
                </div>
                <h3 className="product-card-title">
                  Inefficient route management
                </h3>
                <p className="product-card-desc">
                  Ad-hoc routes and no optimization lead to wasted time and
                  fuel.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.Clock />
                </div>
                <h3 className="product-card-title">
                  Idle time going unnoticed
                </h3>
                <p className="product-card-desc">
                  Unproductive stops and downtime are invisible without
                  tracking.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.File />
                </div>
                <h3 className="product-card-title">
                  Manual reporting and delays
                </h3>
                <p className="product-card-desc">
                  Late or incomplete reports slow down decisions and
                  accountability.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.Rupee />
                </div>
                <h3 className="product-card-title">
                  Inaccurate reimbursements
                </h3>
                <p className="product-card-desc">
                  Claims without proof of travel lead to overpayment and
                  disputes.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 4. SOLUTION / FEATURES */}
        <section className="product-section product-section-alt" id="features">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Features</span>
              <h2 className="gen-h2">
                Everything You Need to Track & Optimize Field Work
              </h2>
              <p className="gen-h2-sub">
                Live tracking, productivity monitoring, distance and expense
                tracking, and seamless integration — in one platform.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.MapPin />
                </div>
                <h3 className="product-card-title">Live Location Tracking</h3>
                <p className="product-card-desc">
                  See every field executive's exact location on a live map.
                  Real-time pings every 30 seconds, accurate to 5 metres across
                  pan India.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.User />
                </div>
                <h3 className="product-card-title">Smart Attendance</h3>
                <p className="product-card-desc">
                  Geo-fenced check-ins with selfie verification. Eliminate buddy
                  punching and proxy attendance — attendance marked only at the
                  site.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Route />
                </div>
                <h3 className="product-card-title">Route Intelligence</h3>
                <p className="product-card-desc">
                  Distinguish between working routes and deviation routes. Flag
                  deviations in real time and identify idle time vs productive
                  movement.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Rupee />
                </div>
                <h3 className="product-card-title">Auto Reimbursement</h3>
                <p className="product-card-desc">
                  Distance-based travel reimbursements calculated from actual
                  GPS data. No more inflated claims — finance teams save hours
                  every week.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Phone />
                </div>
                <h3 className="product-card-title">
                  Contact Any Agent, Instantly
                </h3>
                <p className="product-card-desc">
                  Call or message any field executive pan India directly from
                  the dashboard — without needing their personal number.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Target />
                </div>
                <h3 className="product-card-title">Geofencing & Alerts</h3>
                <p className="product-card-desc">
                  Define working zones. Get instant alerts when any executive
                  enters, leaves, or deviates — configurable radius per
                  department.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Dashboard />
                </div>
                <h3 className="product-card-title">
                  Powerful Reports Dashboard
                </h3>
                <p className="product-card-desc">
                  Field activity reports, distance summaries, stoppage logs, and
                  team productivity — export ready for HR, operations, and
                  finance.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Users />
                </div>
                <h3 className="product-card-title">Roles & Permissions</h3>
                <p className="product-card-desc">
                  Granular role-based access. Managers see only their teams,
                  admins see everything. Fully configurable per department
                  hierarchy.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 5. SDK INTEGRATION (Code Split) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-split"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div variants={childVariants}>
                <span className="product-section-eyebrow">SDK</span>
                <h2 className="gen-h2">
                  Embed Tracking Into Your Existing Application
                </h2>
                <p className="gen-h2-sub" style={{ marginBottom: "4rem" }}>
                  Integrate seamlessly with your existing systems. No need to
                  change your app — plug-and-play SDK for faster rollout.
                </p>

                <div className={styles["product-integration-step"]}>
                  <div className={styles["product-step-circle"]}>1</div>
                  <div className={styles["product-step-text"]}>
                    <h4>Install the SDK</h4>
                    <p>
                      Add our lightweight plugin to your Android or iOS app.
                      Under 200KB. No performance impact, no battery drain.
                    </p>
                  </div>
                </div>
                <div className={styles["product-integration-step"]}>
                  <div className={styles["product-step-circle"]}>2</div>
                  <div className={styles["product-step-text"]}>
                    <h4>Authenticate Your Agents</h4>
                    <p>
                      Pass your existing employee IDs — no re-registration
                      needed. Agents use the app they already have.
                    </p>
                  </div>
                </div>
                <div className={styles["product-integration-step"]}>
                  <div className={styles["product-step-circle"]}>3</div>
                  <div className={styles["product-step-text"]}>
                    <h4>Go Live Instantly</h4>
                    <p>
                      Your admin dashboard lights up with real-time location and
                      attendance — the moment agents open the app.
                    </p>
                  </div>
                </div>
                <div className={styles["product-integration-step"]}>
                  <div className={styles["product-step-circle"]}>4</div>
                  <div className={styles["product-step-text"]}>
                    <h4>Use LiveTracker App Instead</h4>
                    <p>
                      Skip the integration. Just deploy our standalone field
                      agent app. Works out of the box, zero configuration.
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div
                variants={childVariants}
                className="product-code-block hover-inset"
              >
                <pre>
                  <span className="product-code-comment">
                    // Install LiveTracker SDK
                  </span>
                  <br />
                  <span className="product-code-method">npm install</span>{" "}
                  <span className="product-code-url">@product/tracker-sdk</span>
                  <br />
                  <br />
                  <span className="product-code-method">import</span>{" "}
                  {`{ LiveTracker }`}{" "}
                  <span className="product-code-method">from</span>{" "}
                  <span className="product-code-str">
                    '@product/tracker-sdk'
                  </span>
                  ;
                  <br />
                  <br />
                  <span className="product-code-comment">
                    // Initialize once
                  </span>
                  <br />
                  <span className="product-code-key">LiveTracker</span>.init(
                  {`{`}
                  <br />
                  <span className="product-code-key"> apiKey</span>:{" "}
                  <span className="product-code-str">'YOUR_API_KEY'</span>,
                  <br />
                  <span className="product-code-key"> agentId</span>:
                  currentUser.employeeId,
                  <br />
                  <span className="product-code-key"> pollInterval</span>:{" "}
                  <span className="product-code-url">30</span>,<br />
                  {`});`}
                  <br />
                  <br />
                  <span className="product-code-comment">
                    // Start tracking
                  </span>
                  <br />
                  <span className="product-code-key">LiveTracker</span>
                  .startSession();
                  <br />
                  <br />
                  <span className="product-code-comment">
                    // Done. Real-time data flows
                  </span>
                  <br />
                  <span className="product-code-comment">
                    // to your admin dashboard.
                  </span>
                </pre>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 6. BUSINESS IMPACT & DIFFERENTIATORS */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Business Impact</span>
              <h2 className="gen-h2">What Makes Us Stand Out</h2>
            </motion.div>

            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-inset"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dcfce7",
                    color: "#22c55e",
                    borderColor: "#bbf7d0",
                  }}
                >
                  <Icons.TrendingUp />
                </div>
                <h3 className="product-card-title">
                  Improve team productivity
                </h3>
                <p className="product-card-desc">
                  Real-time visibility drives accountability and better
                  outcomes.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dcfce7",
                    color: "#22c55e",
                    borderColor: "#bbf7d0",
                  }}
                >
                  <Icons.Layers />
                </div>
                <h3 className="product-card-title">Reduce inefficiencies</h3>
                <p className="product-card-desc">
                  Optimize routes and reduce idle time and wasted effort.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dcfce7",
                    color: "#22c55e",
                    borderColor: "#bbf7d0",
                  }}
                >
                  <Icons.Rupee />
                </div>
                <h3 className="product-card-title">Better cost control</h3>
                <p className="product-card-desc">
                  Accurate distance and travel data for fair reimbursements.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dcfce7",
                    color: "#22c55e",
                    borderColor: "#bbf7d0",
                  }}
                >
                  <Icons.Zap />
                </div>
                <h3 className="product-card-title">
                  Real-time decision making
                </h3>
                <p className="product-card-desc">
                  Act on live data instead of delayed or manual reports.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 7. COMPARISON TABLE */}
        <section className="product-section">
          <div className="sec-container">
            <div className="product-section-head">
              <span className="product-section-eyebrow">Comparison</span>
              <h2 className="gen-h2">How We Compare</h2>
              <p className="gen-h2-sub">
                We focus on embeddable SDKs and fast deployment without
                replacing your app.
              </p>
            </div>
            <div className="product-table-wrapper">
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th className="highlight-col">Our Platform</th>
                    <th>MapmyIndia</th>
                    <th>FieldSense</th>
                    <th>Lystloc</th>
                    <th>TrackoField</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "Embeddable SDK (embed in your app)",
                      "✓",
                      "—",
                      "—",
                      "—",
                      "—",
                    ],
                    ["Live GPS tracking", "✓", "✓", "✓", "✓", "✓"],
                    [
                      "Check-in / check-out at location",
                      "✓",
                      "✓",
                      "✓",
                      "✓",
                      "—",
                    ],
                    ["Route replay / path history", "✓", "✓", "—", "—", "—"],
                    ["Offline support", "✓", "✓", "—", "—", "—"],
                    ["Custom forms / surveys", "✓", "✓", "—", "—", "—"],
                    ["Auto reimbursement / expense", "✓", "✓", "—", "—", "—"],
                    ["Ease of deployment", "✓", "Limited", "—", "—", "—"],
                    ["API access", "✓", "✓", "—", "—", "—"],
                    ["Cost efficiency", "✓", "—", "—", "—", "—"],
                  ].map((row, i) => (
                    <tr key={i}>
                      <td>{row[0]}</td>
                      <td
                        className="highlight-col"
                        style={{
                          color: row[1] === "✓" ? "#10b981" : "inherit",
                          fontWeight: row[1] === "✓" ? "bold" : "normal",
                        }}
                      >
                        {row[1]}
                      </td>
                      <td>{row[2]}</td>
                      <td>{row[3]}</td>
                      <td>{row[4]}</td>
                      <td>{row[5]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* 8. TESTIMONIALS */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Testimonials</span>
              <h2 className="gen-h2">What Our Customers Say</h2>
            </motion.div>

            <div className="product-grid-3">
              <div className="product-test-card hover-tilt">
                <div className="product-stars">★★★★★</div>
                <p className="product-quote">
                  "We now have complete visibility of our field agents.
                  Productivity has improved and we can make decisions in real
                  time."
                </p>
                <div className="product-author">
                  <div
                    className="product-author-avatar"
                    style={{ background: "#3b82f6" }}
                  >
                    RK
                  </div>
                  <div className="product-author-info">
                    <p className="product-author-name">Rahul K.</p>
                    <p className="product-author-role">Operations Head, NBFC</p>
                  </div>
                </div>
              </div>
              <div className="product-test-card hover-tilt">
                <div className="product-stars">★★★★★</div>
                <p className="product-quote">
                  "The SDK let us add tracking to our existing app without
                  disrupting workflows. Rollout was fast and smooth."
                </p>
                <div className="product-author">
                  <div
                    className="product-author-avatar"
                    style={{ background: "#10b981" }}
                  >
                    PM
                  </div>
                  <div className="product-author-info">
                    <p className="product-author-name">Priya M.</p>
                    <p className="product-author-role">Field Manager, FMCG</p>
                  </div>
                </div>
              </div>
              <div className="product-test-card hover-tilt">
                <div className="product-stars">★★★★★</div>
                <p className="product-quote">
                  "Travel claims are now accurate and audit-ready. We saved
                  costs and reduced disputes significantly."
                </p>
                <div className="product-author">
                  <div
                    className="product-author-avatar"
                    style={{ background: "#4f46e5" }}
                  >
                    AS
                  </div>
                  <div className="product-author-info">
                    <p className="product-author-name">Amit S.</p>
                    <p className="product-author-role">Head of Collections</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 9. FINAL CTA (DARK) */}
        <section className="product-dark-cta">
          <div className="product-hero-ambient" />
          <div className="sec-container">
            <div
              className="product-cta-grid"
              style={{ gridTemplateColumns: "1fr", textAlign: "center" }}
            >
              <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
                <span
                  className="product-eyebrow"
                  style={{
                    backgroundColor: "rgba(16, 185, 129, 0.1)",
                    color: "#34d399",
                    borderColor: "rgba(16, 185, 129, 0.3)",
                  }}
                >
                  Get Started Today
                </span>
                <h2 className="product-h1" style={{ fontSize: "4.8rem" }}>
                  Stop Guessing.
                  <br />
                  Start Knowing.
                </h2>
                <p className="product-lead" style={{ marginBottom: "4rem" }}>
                  Join 1,400+ field executives and their managers already using
                  Live Tracker across India.
                </p>
                <div
                  className="product-cta-group"
                  style={{ justifyContent: "center" }}
                >
                  <a
                    href="mailto:support@doql.com"
                    className="product-btn product-btn-primary"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Contact: support@doql.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LiveTracker;
